<template>
  <StreamPlatformForm
    :platform-key="'youtube'"
    :close-modal="closeModal"
    :cast-details="castDetails"
    :step-three-props="stepThreeProps"
    :handle-edit-cast="handleEditCast"
  />
</template>

<script>
import StreamPlatformForm from './StreamPlatformForm.vue';

export default {
  name: 'YoutubeStreamModal',
  props: ['closeModal', 'castDetails', 'stepThreeProps', 'handleEditCast'],
  components: { StreamPlatformForm },
};
</script>
